<template>
  <v-container class="pa-0">   
    <div class="d-flex mt-4">
      <v-text-field
        v-if="showSearch"
        v-model="search"
        prepend-icon="mdi-magnify"
        label="Sök"
        single-line
        hide-details
        clearable
        color="secondary"
        class="pt-0"
      ></v-text-field>
      <v-spacer v-if="!showSearch"></v-spacer>
      <div>
        <v-tooltip
          left
          v-for="button in buttons"
          :key="button.label"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              @click="onButton(button)"
            >
              <v-icon>mdi-{{ button.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ button.title }}</span>
        </v-tooltip>
      </div>
    </div>
    <v-data-table
      :headers="tableData.listData.header_ar"
      :items="tableData.listData.item_ar"
      :items-per-page="tableData.itemsPerPage"
      :item-class="getRowClass"
      :hide-default-header="!hasAnyItems"
      :hide-default-footer="!hasAnyItems"
      :search="filterable ? search : null"
      @click:row="showObject"
      class="xClickRowTable"
      ref="data-table"
    >
      <template v-slot:[`item.hasBeenAssigned`]="{ item }">
        <v-tooltip
          left
          dark
          color="accent"
        >
          <template v-slot:activator="{ on }">
            <v-icon
              v-on="on"
              v-if="item.hasBeenAssigned"
              color="accent"
            >
              mdi-check
            </v-icon>
          </template>
          <span v-show="item.hasSigned">Tilldelat</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <div class="text-left">
          {{ txtNoTableData }}
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { downloadMixin } from '../mixins/download'

export default {
  props: {
    tableData: {
      type: Object,
      required: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    txtNoTableData: {
      type: String,
      default: 'Inga objekt finns'
    },
    downloadable: {
      type: Boolean,
      default: false
    },
    addable: {
      type: Boolean,
      default: false
    },
    txtButtonAdd: {
      type: String,
      default: 'Lägg till'
    }
  },
  mixins: [downloadMixin],
  data: () => ({
    search: null,
  }),
  computed: {
    hasAnyItems() {
      return this.tableData.listData.item_ar.length != 0
    },
    showSearch() {
      return this.filterable && this.hasAnyItems
    },
    buttons() {
      let buttons = []
      if (this.downloadable && this.hasAnyItems) {
        buttons.push({
          label: 'download',
          title: 'Hämta som Excel',
          icon: 'file-download-outline'
        })
      }
      if (this.addable) {
        buttons.push({
          label: 'add',
          title: this.txtButtonAdd,
          icon: 'plus'
        })
      }
      return buttons
    }
  },
  methods: {
    onButton(button) {
      switch(button.label) {
        case 'download':
          this.downloadExcel()
        break
        default:
          this.$emit('onButton', button)
      }
    },
    getRowClass(item) {
      return item.cmpDeveloper ? 'developer-text' : ''
    },
    showObject(value) {
      this.$router.push({ name: 'admin-' + this.tableData.label, params: { uuid: value.uuid } })
    },
    downloadExcel() {
      const fileLabel = 'admin-' + this.tableData.label
      const refName = 'data-table'
//      const dataTable = this.$refs[refName][0]; //when multiple data tables in same view
      const dataTable = this.$refs[refName];
      this.download_downloadDataTable(fileLabel, dataTable)
    },
  },
  created() {
    console.log("created tableData", this.tableData)
  }
}
</script>

<style>

</style>